var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from 'mobx';
import { PaymentMethod, TicketPayment } from '../../Models/TicketPayment';
import { api } from '../../helpers/Api';
export class TempDuePaymentsStore {
    constructor() {
        this.init = () => {
            this._amountCash = 0;
            this._amountCard = 0;
            this._amountTransfer = 0;
            this._amountOther = 0;
            this._totalDue = null;
        };
        this.send = (item) => {
            console.log('TempDuePaymentsStore - send - item: ', item);
            return api.post(`/ticketPaymentDue/${item.numero}`, this.toJSON());
        };
        this.init();
    }
    // getters
    get amountCash() {
        return this._amountCash;
    }
    get amountCard() {
        return this._amountCard;
    }
    get amountTransfer() {
        return this._amountTransfer;
    }
    get amountOther() {
        return this._amountOther;
    }
    get totalToDue() {
        return this._amountCash + this._amountCard + this._amountTransfer + this._amountOther;
    }
    reset() {
        this.init();
    }
    // setters
    setTotalDue(totalDue) {
        this._totalDue = totalDue;
    }
    setAllMoneyToPaymentMethod(method) {
        console.log('setAllMoneyToPaymentMethod - method: ', method);
        if (!method || this._totalDue === null) {
            return;
        }
        switch (method) {
            case PaymentMethod.Cash:
                this.setAllMoneyToCash();
                break;
            case PaymentMethod.Card:
                this.setAllMoneyToCard();
                break;
            case PaymentMethod.Transfer:
                this.setAllMoneyToTransfer();
                break;
            case PaymentMethod.Other:
                this.setAllMoneyToOther();
                break;
            default:
        }
    }
    setAllMoneyToCash() {
        this._amountCash = this._totalDue;
        this._amountCard = 0;
        this._amountTransfer = 0;
        this._amountOther = 0;
    }
    setAllMoneyToCard() {
        this._amountCash = 0;
        this._amountCard = this._totalDue;
        this._amountTransfer = 0;
        this._amountOther = 0;
    }
    setAllMoneyToTransfer() {
        this._amountCash = 0;
        this._amountCard = 0;
        this._amountTransfer = this._totalDue;
        this._amountOther = 0;
    }
    setAllMoneyToOther() {
        this._amountCash = 0;
        this._amountCard = 0;
        this._amountTransfer = 0;
        this._amountOther = this._totalDue;
    }
    setPayment(method, amount) {
        console.log('setPayment - method: ', method);
        console.log('setPayment - amount: ', amount);
        switch (method) {
            case PaymentMethod.Cash:
                this._amountCash = amount;
                break;
            case PaymentMethod.Card:
                this._amountCard = amount;
                break;
            case PaymentMethod.Transfer:
                this._amountTransfer = amount;
                break;
            case PaymentMethod.Other:
                this._amountOther = amount;
                break;
            default:
        }
        console.log('setPayment - this._amountCash: ', this._amountCash);
    }
    toJSON() {
        const payments = [];
        if (this._amountCash > 0) {
            const tempPayment = new TicketPayment(PaymentMethod.Cash);
            tempPayment.setAmount(this._amountCash);
            tempPayment.user = this.user.username;
            tempPayment.user_id = this.user.id;
            tempPayment.terminal = this.terminal;
            payments.push(tempPayment);
        }
        if (this._amountCard > 0) {
            const tempPayment = new TicketPayment(PaymentMethod.Card);
            tempPayment.setAmount(this._amountCard);
            tempPayment.user = this.user.username;
            tempPayment.user_id = this.user.id;
            tempPayment.terminal = this.terminal;
            payments.push(tempPayment);
        }
        if (this._amountTransfer > 0) {
            const tempPayment = new TicketPayment(PaymentMethod.Transfer);
            tempPayment.setAmount(this._amountTransfer);
            tempPayment.user = this.user.username;
            tempPayment.user_id = this.user.id;
            tempPayment.terminal = this.terminal;
            payments.push(tempPayment);
        }
        if (this._amountOther > 0) {
            const tempPayment = new TicketPayment(PaymentMethod.Other);
            tempPayment.setAmount(this._amountOther);
            tempPayment.user = this.user.username;
            tempPayment.user_id = this.user.id;
            tempPayment.terminal = this.terminal;
            payments.push(tempPayment);
        }
        return {
            payments
        };
    }
}
__decorate([
    observable
], TempDuePaymentsStore.prototype, "_totalDue", void 0);
__decorate([
    observable
], TempDuePaymentsStore.prototype, "_amountCash", void 0);
__decorate([
    observable
], TempDuePaymentsStore.prototype, "_amountCard", void 0);
__decorate([
    observable
], TempDuePaymentsStore.prototype, "_amountTransfer", void 0);
__decorate([
    observable
], TempDuePaymentsStore.prototype, "_amountOther", void 0);
__decorate([
    computed
], TempDuePaymentsStore.prototype, "totalToDue", null);
__decorate([
    action
], TempDuePaymentsStore.prototype, "reset", null);
__decorate([
    action
], TempDuePaymentsStore.prototype, "setAllMoneyToPaymentMethod", null);
__decorate([
    action
], TempDuePaymentsStore.prototype, "setPayment", null);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/TempDuePaymentsStore.ts
// module id = 574
// module chunks = 0